/* Product cards: the two little colour dots flip the picture between black and white.
   Hovering a dot previews it; a tap or click keeps it. On a phone the picture swipes between
   its two sides (CSS scroll-snap); the two dots under it follow the swipe. */
(function () {
  function pick(card, colour) {
    if (!card || !colour) return;
    card.setAttribute('data-colour', colour);
    // the other colour's layer starts on its front again
    card.querySelectorAll('.card__layer').forEach(function (l) { l.scrollLeft = 0; });
    card.classList.remove('is-end');
    card.querySelectorAll('.card__dots i').forEach(function (d, n) { d.classList.toggle('is-on', n === 0); });
  }
  document.addEventListener('scroll', function (e) {
    var layer = e.target;
    if (!layer || !layer.classList || !layer.classList.contains('card__layer')) return;
    var card = layer.closest('[data-card]'), dots = card ? card.querySelectorAll('.card__dots i') : [];
    var i = layer.clientWidth ? Math.round(layer.scrollLeft / layer.clientWidth) : 0;
    dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    if (card) card.classList.toggle('is-end', layer.scrollLeft + layer.clientWidth >= layer.scrollWidth - 1.5);
  }, true);
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest('[data-swatch]');
    if (dot) pick(dot.closest('[data-card]'), dot.getAttribute('data-swatch'));
  });
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-swatch]');
    if (!dot) return;
    e.preventDefault();
    pick(dot.closest('[data-card]'), dot.getAttribute('data-swatch'));
  });
  document.addEventListener('focusin', function (e) {
    var dot = e.target.closest('[data-swatch]');
    if (dot) pick(dot.closest('[data-card]'), dot.getAttribute('data-swatch'));
  });
})();
